import {Center} from '@chakra-ui/react';

import {Coins1, Coins2, Coins3, Coins4} from '../icons';

type Props = {
  coins: number;
};

export const CoinsIcon = ({coins}: Props) => (
  <Center w="clamp(2.5rem, 6.66vw, 6rem)" h="clamp(2.5rem, 6.66vw, 6rem)">
    <GetIcon coins={coins} />
  </Center>
);

const GetIcon = ({coins}: Props) => {
  switch (true) {
    case coins < 1_000:
      return <Coins1 />;
    case coins < 10_000:
      return <Coins2 />;
    case coins < 100_000:
      return <Coins3 />;
    case coins >= 100_000:
      return <Coins4 />;
    default:
      return <Coins1 />;
  }
};
